import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_c('the-menu'),_c(VMain,[_c(VContainer,{staticClass:"fill-height pa-0",attrs:{"fluid":""}},[_c('div',{staticClass:"fill-height d-flex flex-column",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"flex-grow-1"},[_c('div',{staticStyle:{"height":"100%"}},[_c('the-map')],1)])])])],1),_c('the-snackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }